export default "__VITE_ASSET__DpG380A6__"